// src/App.js

import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PrivateRoute } from './routes/PrivateRoute';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import LoginForm from './components/LoginForm';
import RoleSelection from './components/RoleSelection';
import Home from './components/Home';

// Employer Components
import ScheduleManagement from './components/employer/ScheduleManagement';
import Employees from './components/employer/Employees';
import ViewAvailability from './components/employer/ViewAvailability';

// Employee Components
import MySchedule from './components/employee/MySchedule';
import Availability from './components/employee/Availability';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// Fetch users as a sample API request
fetch(`${API_BASE_URL}/users`)
  .then(response => response.json())
  .then(data => console.log(data));

// Layout component for authenticated pages
const AuthenticatedLayout = () => {
  const { currentUser } = useAuth();
  return (
    <>
      {currentUser && <NavBar />}
      <main className="flex-grow-1">
        <Outlet />
      </main>
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="d-flex flex-column min-vh-100">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<LoginForm />} />
            
            {/* Protected routes with navbar */}
            <Route element={<AuthenticatedLayout />}>
              <Route 
                path="/role-selection" 
                element={<PrivateRoute><RoleSelection /></PrivateRoute>} 
              />
              <Route 
                path="/home" 
                element={<PrivateRoute><Home /></PrivateRoute>} 
              />
              
              {/* Employer routes */}
              <Route 
                path="/schedule-management" 
                element={<PrivateRoute><ScheduleManagement /></PrivateRoute>} 
              />
              <Route 
                path="/view-availability" 
                element={<PrivateRoute><ViewAvailability /></PrivateRoute>} 
              />
              <Route 
                path="/employees" 
                element={<PrivateRoute><Employees /></PrivateRoute>} 
              />
              
              {/* Employee routes */}
              <Route 
                path="/my-schedule" 
                element={<PrivateRoute><MySchedule /></PrivateRoute>} 
              />
              <Route 
                path="/availability" 
                element={<PrivateRoute><Availability /></PrivateRoute>} 
              />
              
              {/* Default redirect */}
              <Route path="/" element={<Navigate to="/home" />} />
            </Route>
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
